const ALL = {
  rw: 'payments.u2s/all:rw',
  r: 'payments.u2s/all:r'
}

const TRANSACTIONAL = {
  rw: 'payments.u2s/transactional:rw',
  r: 'payments.u2s/transactional:r'
}
const FINANCIAL = {
  rw: 'payments.u2s/financial:rw',
  r: 'payments.u2s/financial:r'
}
const RECIPIENTS = {
  rw: 'payments.u2s/recipients:rw',
  r: 'payments.u2s/recipients:r'
}

export { ALL, TRANSACTIONAL, FINANCIAL, RECIPIENTS }
